import { render, staticRenderFns } from "./AddAction.vue?vue&type=template&id=bc279cd6"
import script from "./AddAction.vue?vue&type=script&lang=js"
export * from "./AddAction.vue?vue&type=script&lang=js"
import style0 from "./AddAction.vue?vue&type=style&index=0&id=bc279cd6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports